import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/Index'
import NoiseAverage from '@/components/NoiseAverage'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/average',
      name: 'Average',
      component: NoiseAverage
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js